import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Generic registry for navigation item badge counts. Feature services register
 * their badge counts here; the navigation component reads from this service rather
 * than importing feature services directly.
 */
@Injectable({ providedIn: 'root' })
export class NavBadgeService {
    private readonly _counts = new BehaviorSubject<Map<string, number | undefined>>(new Map());

    /** Emits the full path→count map whenever any badge count changes. */
    readonly badgeCounts$ = this._counts.asObservable();

    setBadge(path: string, count: number | undefined): void {
        const next = new Map(this._counts.value);
        next.set(path, count);
        this._counts.next(next);
    }

    getBadgeCounts(): Map<string, number | undefined> {
        return new Map(this._counts.value);
    }
}
